import { render, staticRenderFns } from "./seeDetail.vue?vue&type=template&id=0897a78a&scoped=true&"
import script from "./seeDetail.vue?vue&type=script&lang=js&"
export * from "./seeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897a78a",
  null
  
)

export default component.exports